import { USER_INFO, USER_INFO_ERROR, USER_INFO_SUCCESS, SET_HOLDER, SET_PLANS, SET_ORGANIZATION, SET_ORGANIZATIONS, SET_SETTINGS_NOTIFICATIONS, SET_TOTAL_NOTIFICATIONS, SET_USER, } from '../actions';
export var userInfo = function () { return ({
    type: USER_INFO,
}); };
export var userInfoSuccess = function () { return ({
    type: USER_INFO_SUCCESS,
}); };
export var userInfoError = function (message) { return ({
    type: USER_INFO_ERROR,
    payload: { message: message },
}); };
export var setUser = function (data) { return ({
    type: SET_USER,
    payload: data,
}); };
export var setHolder = function (data) { return ({
    type: SET_HOLDER,
    payload: data,
}); };
export var setPlans = function (data) { return ({
    type: SET_PLANS,
    payload: data,
}); };
export var setOrganization = function (data) { return ({
    type: SET_ORGANIZATION,
    payload: data,
}); };
export var setOrganizations = function (data) { return ({
    type: SET_ORGANIZATIONS,
    payload: data,
}); };
export var setTotalNotifications = function (total) { return ({
    type: SET_TOTAL_NOTIFICATIONS,
    payload: total <= 0 ? 0 : total,
}); };
export var setSettingsNotifications = function (key, value) { return ({
    type: SET_SETTINGS_NOTIFICATIONS,
    payload: { key: key, value: value },
}); };
